import { render } from "./HeaderAuth.vue?vue&type=template&id=519568c6&scoped=true"
import script from "./HeaderAuth.vue?vue&type=script&lang=js"
export * from "./HeaderAuth.vue?vue&type=script&lang=js"

import "./HeaderAuth.vue?vue&type=style&index=0&id=519568c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-519568c6"]])

export default __exports__